import Configs from 'infrastructure/config/environment'

function appUrl(): string {
  return Configs().AppUrl
}

function pathUrl(path: string) {
  return `${appUrl()}${path}`
}

export function curriculaUrl(currculaId: number | string) {
  const path = `/curriculum/${currculaId}`
  return pathUrl(path)
}

export function directTreeAccessUrl({
  treeId,
  versionId,
  nodeId,
}: {
  treeId: string
  versionId: string
  nodeId?: string
}) {
  let path = `/curriculum/${treeId}:${versionId}`
  if (nodeId) {
    path += `/node/${treeId}:${versionId}:${nodeId}`
  }
  return pathUrl(path)
}

export function previewUrl({
  partnerKey,
  ingestionKey,
}: {
  partnerKey: string
  ingestionKey: string
}) {
  const path = `/ingestion/${partnerKey}/${ingestionKey}`
  return pathUrl(path)
}

export function mappingReviewUrl({
  fromTree,
  toTree,
  filters,
  index,
}: {
  fromTree: { tree_id: string; version: string }
  toTree: { tree_id: string; version: string }
  filters: string[]
  index: number
}) {
  const path = `/version_mapping/from/${fromTree.tree_id}:${
    fromTree.version
  }/to/${toTree.tree_id}:${toTree.version}?rf=${filters.join(',')}&ri=${index}`
  return 'https://' + window.location.host + path
}

export function directTKatTreeAccessUrl({
  nodeId,
  versionId,
  treeId,
}: {
  treeId: string
  versionId: string
  nodeId?: string
}) {
  const path = `/tree_management/${treeId}:${versionId}?tMgmt=Tree+Builder&nodeId=${nodeId}`
  return Configs().TKatUrl + path
}
